import React from "react";
import { useTranslation } from "react-i18next";

function VideoTutorial() {
  const { t } = useTranslation();
  
  return (
    <div className="max-w-5xl mx-auto">
      <h2 className="text-2xl md:text-3xl font-bold text-slate-900 dark:text-white text-center mb-6">
        {t("videoTutorial")}
      </h2>
      <div className="relative aspect-video w-full overflow-hidden rounded-2xl border border-slate-200/70 dark:border-slate-700/80 bg-black shadow-xl">
        <video
          className="w-full h-full object-contain"
          controls
          preload="metadata"
        >
          <source src="/Video.mp4" type="video/mp4" />
          {t("videoNoSupport")}
        </video>
      </div>
    </div>
  );
}

export default VideoTutorial;
